// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Isen","inputWrap":"CustomTip_inputWrap__bObUZ"};